module.exports = __webpack_public_path__ + "img/Magnuss40.33cb9476.jpg";